import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  successMode: false,
  successMessage: "",
};

type SetSuccessModePayload = | boolean | { enabled: boolean; message: string };

export const successModeSlice = createSlice({
  name: 'successMode',
  initialState,
  reducers: {
    SET_SUCCESS_MODE: (state, action: PayloadAction<SetSuccessModePayload>) => {
      if (typeof action.payload === 'boolean') {
        state.successMode = action.payload;
        state.successMessage = action.payload ? state.successMessage : "";
      } else {
        state.successMode = action.payload.enabled;
        state.successMessage = action.payload.enabled
          ? action.payload.message ?? ""
          : "";
      }
    },
  },
});

export const { SET_SUCCESS_MODE } = successModeSlice.actions;

